module.exports = __webpack_public_path__ + "img/image2.bf0fee7e.png";